<mat-dialog-content class="p-0">
  <clm-home [showHomeButton]="data.showHomeButton"></clm-home>
</mat-dialog-content>

<mat-dialog-actions class="justify-content-end">
  <button mat-button matDialogClose>{{ "HOME.CLOSE" | translate }}</button>
</mat-dialog-actions>
